import { useScrollReveal } from "@/hooks/useScrollReveal";

const tags = [
  "未経験OK",
  "シニア歓迎",
  "日払いOK",
  "週払いOK",
  "入社祝い金あり",
  "週シフト制",
];

export default function RecruitIntroSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section className="bg-white py-16 md:py-24" id="recruit-intro">
      <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
        <div
          ref={ref}
          className={`text-center transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-[28px] md:text-4xl lg:text-5xl font-black text-navy leading-tight mb-8">
            今すぐ働ける。<br className="md:hidden" />アルバイト・未経験・シニアも歓迎。
          </h2>

          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {tags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-1.5 bg-navy/5 text-navy font-bold text-sm px-4 py-2 rounded-full border border-navy/10"
              >
                <span className="w-4 h-4 flex items-center justify-center text-gold">
                  <i className="ri-check-line"></i>
                </span>
                {tag}
              </span>
            ))}
          </div>

          <div className="mb-8">
            <p className="text-sm text-gray-500 mb-2">給与</p>
            <p className="text-4xl md:text-5xl font-black text-gold">
              日給 10,000円〜20,000円
            </p>
          </div>

          <p className="text-gray-600 leading-loose max-w-3xl mx-auto text-base md:text-lg">
            大阪を中心に、交通誘導・イベント・高速道路など様々な現場で活躍するスタッフを随時募集中。
            真面目に長く働いてくれる方を大歓迎します。
          </p>
        </div>
      </div>
    </section>
  );
}